'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.finally = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};



//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/vasternorrlands-museum/public/wp-content/themes/murberget/node_modules/promise/lib/finally.js
// module id = 159
// module chunks = 0